{
  "generic": "Gözlənilməz xəta baş verdi",
  "network": "Şəbəkə xətası. Bağlantınızı yoxlayın.",
  "notFound": "Səhifə tapılmadı",
  "forbidden": "İcazə yoxdur",
  "tryAgain": "Yenidən cəhd edin"
}
